import { useMutation } from '@tanstack/react-query'

import { deleteCustomerFileAttachment } from './services/deleteCustomerFileAttachment'
import { invalidLoadCustomerById } from './useLoadCustomer'

export const useDeleteCustomerFileAttachment = () => {
  const mutation = useMutation({
    mutationFn: async ({ id }: { id: number; customerId: string }) =>
      await deleteCustomerFileAttachment(id),
    onSuccess: async (_, { customerId }) =>
      await invalidLoadCustomerById(customerId),
  })

  const deleteCustomerFileAttachmentReq = async ({
    id,
    customerId,
  }: {
    id: number
    customerId: string
  }) => {
    return mutation.mutateAsync({ id, customerId })
  }

  return {
    deleteCustomerFileAttachment: deleteCustomerFileAttachmentReq,
    ...mutation,
  }
}
